<mat-stepper [orientation]="isHandset ? 'vertical' : 'horizontal'" #stepper>
  <!-- Step 1: Osnovni podaci o udruzi -->
  <mat-step label="I. Osnovni podaci o udruzi">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">I. Osnovni podaci o udruzi</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (basicInfoFieldValues.length > 0) {
          @for (field of basicInfoFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span>
                    @switch (field.type) {
                      @case ('date') {
                        {{ field.value | date:'d.M.yyyy.' }}
                      }
                      @case ('number') {
                        {{ field.value }}
                      }
                      @default {
                        {{ field.value }}
                      }
                    }
                  </span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- Step 2: Podaci o sjedištu -->
  <mat-step label="II. Podaci o sjedištu">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">II. Podaci o sjedištu</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (headquartersFieldValues.length > 0) {
          @for (field of headquartersFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span> {{ field.value }}</span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- Step 3: Dodatni podaci -->
  <mat-step label="III. Dodatni podaci">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">III. Dodatni podaci</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (additionalDataFieldValues.length > 0) {
          @for (field of additionalDataFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span> {{ field.value }}</span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>
</mat-stepper>